var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJellyfish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55.43 55.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 1.5px;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        fill: none;\n        stroke: #8af3e5;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-3 {\n        stroke-width: .5px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 21.17,
    y1: 11.78,
    x2: 18.26,
    y2: 4.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 37.17,
    y1: 50.71,
    x2: 34.27,
    y2: 43.65
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 11.78,
    y1: 34.27,
    x2: 4.72,
    y2: 37.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 50.71,
    y1: 18.26,
    x2: 43.65,
    y2: 21.17
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 11.82,
    y1: 21.08,
    x2: 4.77,
    y2: 18.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 50.66,
    y1: 37.3,
    x2: 43.62,
    y2: 34.35
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 21.08,
    y1: 43.62,
    x2: 18.14,
    y2: 50.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 37.29,
    y1: 4.77,
    x2: 34.35,
    y2: 11.82
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.86,27.72c0,9.47-7.67,17.14-17.14,17.14s-17.14-7.67-17.14-17.14S18.25,10.57,27.72,10.57s17.14,7.67,17.14,17.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M29.75,20.14c0,2.85-2.31,5.17-5.17,5.17s-5.17-2.31-5.17-5.17,2.31-5.17,5.17-5.17,5.17,2.31,5.17,5.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M21.41,30.29c0,1.24-1,2.24-2.24,2.24s-2.24-1-2.24-2.24,1-2.24,2.24-2.24,2.24,1,2.24,2.24Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 27.72,
    y1: 10.49,
    x2: 27.72,
    y2: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 27.72,
    y1: 54.93,
    x2: 27.72,
    y2: 44.95
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 10.49,
    y1: 27.72,
    x2: 0.5,
    y2: 27.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 54.93,
    y1: 27.72,
    x2: 44.95,
    y2: 27.72
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 15.53,
    y1: 15.53,
    x2: 8.47,
    y2: 8.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 46.96,
    y1: 46.96,
    x2: 39.9,
    y2: 39.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 15.53,
    y1: 39.9,
    x2: 8.47,
    y2: 46.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 46.96,
    y1: 8.47,
    x2: 39.9,
    y2: 15.53
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJellyfish);
export default __webpack_public_path__ + "static/media/jellyfish.0c3fb356233496e5e68f3d2827e10aad.svg";
export { ForwardRef as ReactComponent };